// extracted by mini-css-extract-plugin
export default {"heading":"pt-z","corrected":"qt-z","redirectVerbiageContainer":"rt-z","redirectVerbiageText":"st-z"};